<template>
  <a-modal modal-id="result-filters-modal">
    <div slot="title">Result Templates</div>
    <div slot="form">
      <div class="row">
        <label>Name</label>
        <input type="text" v-model="fData.name" class="form-control" placeholder="Name">
      </div>
      <div class="row m-t-xs">
        <div class="col-lg-6" v-if="f && f.filterOptions && f.filterOptions.results">
          <div v-for="opt in f.filterOptions.results.pbn" :key="opt.field">
            <input type="checkbox" :id="'cb-' + opt.field" v-model="selectedFields[opt.field]" @change="refreshSelectedResults"> <label :for="'cb-' + opt.field">{{ opt.name }}</label>
          </div>
        </div>
        <div class="col-lg-6">
          <div v-for="fi in filteredFields" :key="'filt-' + fi">{{ fi }}</div>
        </div>
      </div>
      <div class="row m-t-sm">
        <button class="btn-sm btn-primary btn" @click="saveResult">Save</button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapGetters } from 'vuex'
// import axios from 'axios'

export default {
  data () {
    return {
      fData: {},
      res: [],
      selectedFields: {},
      filteredFields: {}
    }
  },
  components: {
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  props: ['result'],
  watch: {
    result (r) {
      this.fData = r
    }
  },
  methods: {
    refreshSelectedResults () {
      this.filteredFields = []
      this.filteredFields = Object.keys(this.selectedFields).filter(k => this.selectedFields[k] === true)
    },
    async saveResult () {
      try {
        await this.$store.dispatch('postUserFilter', {
          name: this.fData.name,
          filters: this.filteredFields,
          type: 'result',
          path: 'pbn'
        })
        // await axios.post(`/user/filters`, {
        //   name: this.fData.name,
        //   filters: this.filteredFields,
        //   type: 'result',
        //   path: 'pbn'
        // })
        this.$toastr.success('Result template successfully saved')
        this.fData = {}
        $('#result-filters-modal').modal('hide')
        this.selectedFields = {}
        this.filteredFields = {}
        await this.$store.dispatch('loadFilters')
      } catch (e) {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Build/Filters/ResultsModal.vue